module.exports = "<div id=\"venued\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/venue-template-editor/venue-template-editor.component.html
// module id = ./src/app/modules/common-module/components/venue-template-editor/venue-template-editor.component.html
// module chunks = 9